import { useState, useEffect } from 'react';
import { getUsers, toggleUser, deleteUser } from '../services/api';

export default function Customers() {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');

  useEffect(() => { load(); }, []);

  const load = async () => {
    setLoading(true);
    try {
      const all = await getUsers();
      setCustomers(all.filter(u => u.role === 'customer'));
    } catch (e) {}
    setLoading(false);
  };

  const handleToggle = async (id, name) => {
    if (!window.confirm(`Toggle status for ${name}?`)) return;
    try { await toggleUser(id); load(); } catch (e) { alert('Failed'); }
  };

  const handleRemove = async (id, name) => {
    if (!window.confirm(`Remove customer "${name}"? This will deactivate their account.`)) return;
    try { await deleteUser(id); load(); } catch (e) { alert(e.response?.data?.detail || 'Failed'); }
  };

  const filtered = customers.filter(u => {
    if (!search.trim()) return true;
    const q = search.toLowerCase();
    return String(u.id).includes(q) ||
           u.name.toLowerCase().includes(q) ||
           u.email.toLowerCase().includes(q) ||
           (u.phone || '').includes(q);
  });

  return (
    <div>
      <div className="page-header">
        <h1>🛒 Customers</h1>
        <p>All registered customers</p>
      </div>
      <div className="card">
        <div className="card-header">
          <h2>Customers ({filtered.length})</h2>
          <div style={{ display: 'flex', gap: 8 }}>
            <input
              placeholder="🔍 Search by ID, name, email, phone..."
              value={search}
              onChange={e => setSearch(e.target.value)}
              style={{ padding: '6px 12px', border: '1px solid #ddd', borderRadius: 8, fontSize: 13, width: 260 }}
            />
            <button className="refresh-btn" onClick={load}>🔄 Refresh</button>
          </div>
        </div>
        {loading ? <div className="loading">Loading...</div> : (
          <div className="table-wrapper">
            <table>
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>Wallet</th>
                  <th>Referral Code</th>
                  <th>Status</th>
                  <th>Joined</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {filtered.map(u => (
                  <tr key={u.id}>
                    <td>#{u.id}</td>
                    <td><strong>{u.name}</strong></td>
                    <td style={{ fontSize: 13 }}>{u.email}</td>
                    <td style={{ color: '#1565c0', fontWeight: 600 }}>📞 {u.phone}</td>
                    <td>₹{Number(u.wallet_balance || 0).toFixed(2)}</td>
                    <td><code style={{ background: '#f5f5f5', padding: '2px 6px', borderRadius: 4 }}>{u.referral_code || '—'}</code></td>
                    <td>
                      {u.is_active
                        ? <span className="badge badge-success">Active</span>
                        : <span className="badge badge-danger">Inactive</span>}
                    </td>
                    <td>{u.created_at?.substring(0, 10)}</td>
                    <td>
                      <div style={{ display: 'flex', gap: 6 }}>
                        <button
                          className={`btn btn-sm ${u.is_active ? 'btn-warning' : 'btn-success'}`}
                          onClick={() => handleToggle(u.id, u.name)}
                        >
                          {u.is_active ? 'Deactivate' : 'Activate'}
                        </button>
                        <button className="btn btn-sm btn-danger" onClick={() => handleRemove(u.id, u.name)}>
                          🗑️ Remove
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
